import React from 'react'
import '../../css/Project.css'
import {useNavigate} from 'react-router-dom';
function Project(props) {
  const {title,desc,category,img,rating,teacher,price} = props
  let star=[1, 2, 3, 4,5]
  let idx = 0
  for (let i = 0; i < Math.floor(rating); i++) {
    star[i]="star"
    idx=i+1
  }
  if (rating%1 !==0) {
    star[Math.floor(rating)]="star-half-outline"
    idx=star.indexOf("star-half-outline")+1
  }

  star.fill("star-outline",idx)

  let navigate= useNavigate();
  return (
    <div>
      <div class="cardContainer" style={{cursor:"pointer"}} onClick={()=>navigate("/internationalProjects/project")}>
        <div class="box">
          <div class="px-3 white-2 d-flex flex-column justify-content-between  align-items-start">
            <img src={require('../../resource/global.webp')} className="rounded border border-secondary p-1" style={{ height: "170px", width: "100%" }} alt="" />
          <span class="badge badge-pill badge-secondary" style={{ position: "absolute", left: "20px" }}>{category}</span>
            <h5 className="my-1 cyan-text">{title}</h5>
            <p className="white-3 " >{desc}</p> 
            <div className="projectsReview mb-2">
            {star.map((i)=>{
              return   <ion-icon name={i} style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon> 
            })}
  <span className='text-muted' style={{fontSize:"13px"}}> (Based on 4 review) </span>
</div>
<div className="d-flex justify-content-between align-items-center w-100">

  <div className="white-2 d-flex align-items-center "> 
  <img src={require("../../resource/avater.png")} style={{borderRadius:" 50%  ",background:"orange",width:"50px",height:"50px",overflow:"hidden"}} alt="ss" />
    <h6 className=' mx-1 '>{teacher}</h6>

  </div>
  <div className="p-3 teal darken-3 rounded">INR {price}</div>
</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Project